import { useEffect, useState } from "react";
import { useRegionContext } from "api/settings/region/RegionProvider";
import { FormattedMessage } from "react-intl";
import { HandleModaleBO } from "components/bo/HandleModaleBO";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { TableManager } from "components/bo/admin-table/TableManager";
import { ACTIONS, ENTITIES, VAR_TYPES } from "constants/constants";
import { navigateView, navigateEdit, navigateToParent } from "utils/boHelper";
import Button from "core/buttons/button/Button";

export default function AdminRegions({ action }) {
  const navigate = useNavigate();
  const location = useLocation();
  const { id } = useParams();
  const {
    regionByIdGetter,
    regionCreate,
    regionDeleteById,
    regionList,
    regionListGetter,
    regionUpdateById,
    regionPerId,
  } = useRegionContext();

  const [deleteData, setDeleteData] = useState(null);
  const [inputs, setInputs] = useState([]);
  useEffect(() => {
    regionListGetter();
  }, [regionListGetter]);

  useEffect(() => {
    if (id) {
      regionByIdGetter(id);
    }
  }, [id]);

  const handleDelete = async (regionId) => {
    setDeleteData(regionList.find((e) => e.id === regionId));
  };

  const validateDelete = async (regionId) => {
    try {
      await regionDeleteById(regionId);
    } catch (error) {
      console.error(error);
    }
  };

  const handleCreate = (payload) => {
    try {
      regionCreate(payload);
      navigateToParent(navigate, location);
    } catch (e) {
      console.error(e);
    }
  };

  const handleEdit = (payload) => {
    try {
      regionUpdateById(payload.id, payload);
      navigateToParent(navigate, location);
    } catch (e) {
      console.error(e);
    }
  };

  const formatList = (list) =>
    list.map((elm) => ({
      ...elm,
      parent: elm.parent_id
        ? list.find((e) => e.id === elm.parent_id)?.name
        : "",
    }));

  const formatRegion = (region) =>
    region?.id
      ? {
          ...region,
          parent_id: regionList.find((e) => e.id === region?.parent_id)?.name,
        }
      : "";

  useEffect(() => {
    if (regionList.length > 0) {
      const choices = [{ name: "", value: null }].concat(
        regionList.map((e) => ({
          name: e.name,
          value: e.id.toString(),
        }))
      );
      setInputs([
        { col: "name", mandatory: true, isMissingValue: null },
        {
          col: "parent_id",
          mandatory: false,
          editable: true,
          isMissingValue: null,
          type: VAR_TYPES.DROPDOWN,
          choices,
        },
      ]);
    }
  }, [regionList]);

  // Todo gestion droits admin
  return (
    <div>
      {action === ACTIONS.LIST && (
        <div className="flex">
          <Button
            className="btn-hover-color"
            size="large"
            color="blue"
            onClick={() => navigateView("new", navigate, location)}
          >
            <FormattedMessage
              id={"admin_create_new"}
              defaultMessage={"Nouveau"}
            />
          </Button>
        </div>
      )}
      <br />
      <TableManager
        action={action}
        entity={ENTITIES.REGIONS}
        entityPerId={regionPerId}
        formattedEntity={formatRegion(regionPerId)}
        list={formatList(regionList)}
        inputs={inputs}
        navigateEdit={(propsId) => navigateEdit(propsId, navigate, location)}
        navigateView={(propsId) => navigateView(propsId, navigate, location)}
        handleCreate={handleCreate}
        handleDelete={handleDelete}
        handleEdit={handleEdit}
      />
      <div id="modalDelete">
        <HandleModaleBO
          setDeleteData={setDeleteData}
          validateDelete={validateDelete}
          deleteData={formatRegion(deleteData)}
          entity={ENTITIES.REGIONS}
        />
      </div>
    </div>
  );
}
